/**
 * #1836 — één regel voor Escape: alleen het bovenste venster handelt hem af.
 *
 * Elk modaal venster draagt `aria-modal="true"`; vensters gaan als portal achteraan in de body
 * (of genest in het venster eronder), dus het bovenste is het laatste in documentvolgorde.
 * Een venster zet zijn eigen Escape-luisteraar vaak pas in een effect na het tekenen; zonder
 * deze regel kwam een Escape in dat gat bij het venster eronder aan (E2E 1772: het archiefvenster
 * stond open en de persoon-editor eronder ging dicht).
 */
export function isBovensteVenster(el: Element | null): boolean {
  if (!el) return false;
  const alle = document.querySelectorAll('[aria-modal="true"]');
  return alle.length === 0 || alle[alle.length - 1] === el;
}
